<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - リリース情報登録完了</h3>
      </div>
      <div class="page-block__inner">
        <div class="form-complete-area">
          <div class="form-complete-area__title">サブミット依頼受付完了</div>
          <div class="form-complete-area__lead">「{{ title }}」のサブミット依頼を受け付けました。</div>
          <div class="c-btn-wrap">
            <router-link
              :to="{ name: 'index' }"
              class="c-btn c-btn--back">
              トップへ戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBar from '../HeaderBar'

export default {
  name: 'SubmitCompleted',
  components: { HeaderBar },
  data() {
    return {
      title: null,
      type: 'album',
    }
  },
  mounted() {
    if (!window.sessionStorage.getItem('album')) {
      this.$router.push({ name: 'index' })
      return
    }
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    this.title = release.product.title_ja
    this.type = release.type
    window.sessionStorage.removeItem('album')
  },
}
</script>
